import { useTheme } from '@mui/material/styles';
import { HealthZone, STAFFING_PRIORIRY_ZONES_ALIASES } from 'domain/shared/staffing';

export const useStaffingZoneAccentColor = (zone: HealthZone): string => {
  const theme = useTheme();

  const staffingZoneAccentColor = {
    [STAFFING_PRIORIRY_ZONES_ALIASES.SAFE]: theme.palette.success.main,
    [STAFFING_PRIORIRY_ZONES_ALIASES.MONITORING]: theme.palette.warning.main,
    [STAFFING_PRIORIRY_ZONES_ALIASES.CRITICAL]: theme.palette.error.main,
  };

  return staffingZoneAccentColor[zone];
};
